import { NetworkError } from '@pulsify/shared/network-error'

/** A draft profile that keeps an event from going public. */
export interface DraftHost {
  id: string
  name: string
  /** Its place, when it is a place's profile: publishing the place publishes the profile. */
  listingId?: string
}

type Asker = (host: DraftHost) => Promise<boolean>

let asker: Asker | null = null

/** Registers the dialog that asks whether to publish a draft host along with its event. */
export function onHostPublishRequest(next: Asker): () => void {
  asker = next
  return () => {
    if (asker === next) asker = null
  }
}

/** Asks the person whether the draft host may go public too; no dialog on screen means no. */
export function confirmHostPublish(host: DraftHost): Promise<boolean> {
  return asker ? asker(host) : Promise.resolve(false)
}

/** The draft host a refused event publish names, if that is why it was refused. */
export function draftHostOf(error: unknown): DraftHost | null {
  if (!(error instanceof NetworkError) || error.code !== 'EventHostNotPublished') return null
  const id = error.fieldErrors?.hostProfileId?.[0]
  if (!id) return null
  return {
    id,
    name: error.fieldErrors?.hostName?.[0] ?? '',
    listingId: error.fieldErrors?.hostListingId?.[0],
  }
}
